export default __webpack_public_path__ + "96e576e407b9aa69fe6b4e8096029a4c.png";